import React from "react";
import "./Tooltip.css";

export function Tooltip({ text, children }) {
  return (
    <div className="tooltip-container">
      {children} {/* The button or any other element goes here */}
      <span className="tooltip-text">{text}</span>
    </div>
  );
}